import { useEffect } from 'react';
import { useFormDispatch } from '@elfsight/widget-form-builder/widget';
import { getSiteURL } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { RewardType } from '../../../types';
import { useStorageReward } from '../../use-current-reward';
import {
  LOGO_ID,
  PRIZE_BUTTON_LINK_ID,
  PRIZE_BUTTON_TEXT_ID,
  PRIZE_COUPON_ID,
  PRIZE_HEADING_ID,
  PRIZE_TEXT_ID,
  WEBPAGE_ID
} from './constants';

export function useSpinningWheelFields() {
  const dispatch = useFormDispatch();
  const { logo } = useSettings();

  const dispatchField = (id: string, value?: string | number) => {
    dispatch({
      type: 'changeField',
      field: {
        id,
        value: value || '',
        valid: true
      }
    });
  };

  useEffect(() => {
    dispatchField(WEBPAGE_ID, getSiteURL('page'));
  }, []);

  useEffect(() => {
    dispatchField(LOGO_ID, logo?.url);
  }, [logo?.url]);
}

export const useSyncRewardFields = () => {
  const dispatch = useFormDispatch();
  const { reward: storageReward } = useStorageReward();

  const dispatchField = (id: string, value?: string | number) => {
    dispatch({
      type: 'changeField',
      field: {
        id,
        value: value || '',
        valid: true
      }
    });
  };

  const sync = (reward?: RewardType) => {
    const currentReward = reward || storageReward;

    dispatchField(PRIZE_COUPON_ID, currentReward?.promocode);
    dispatchField(PRIZE_BUTTON_TEXT_ID, currentReward?.actionButtonText);
    dispatchField(PRIZE_BUTTON_LINK_ID, currentReward?.actionButtonLink.value);
    dispatchField(PRIZE_HEADING_ID, currentReward?.label);
    dispatchField(PRIZE_TEXT_ID, currentReward?.text);
  };

  return {
    sync
  };
};
